export const PHARMACY_FOLA_PROMPTS = {
  dashboard_overview:
    "Explain the Pharmacy dashboard cards, prescription counts, income, sold items, and low-stock alerts. Keep it operational and do not expose internal administration data.",
  prescription_processing:
    "Guide me through receiving, reviewing, pricing, preparing, and releasing pharmacy prescriptions in AfriMed. Do not provide clinical diagnosis or override the prescribing clinician.",
  prescription_order:
    "Ask Fola about this prescription order. Explain how to review patient details, medication name, strength, quoted price, fulfilment mode, and order status without changing prescriptions clinically or overriding the issuing clinician.",
  inventory_management:
    "Explain how to manage pharmacy inventory, low-stock alerts, reorder levels, medicine pricing, expiry dates, and stock confidence in AfriMed.",
  add_stock_item:
    "Help me understand how to complete the Add stock item form. Explain each field simply and remind me not to invent medicine availability or pricing.",
  payments_settlement:
    "Explain pharmacy payments, medicine revenue, AfriMed fees, delivery collections, payment readiness, payment links, and settlement previews in AfriMed.",
  team_roles:
    "Explain pharmacy team roles, permissions, staff invitations, CSV import, owner privileges, dispensing pharmacist, inventory manager, finance lead, delivery lead, and branch admin responsibilities.",
  pharmacy_help:
    "Help me find pharmacy guidance for onboarding, profile verification, inventory, prescription fulfilment, payments, messages, alerts, team roles, and technical support in AfriMed.",
};

export function getPharmacyFolaPrompt(promptKey = "") {
  const key = String(promptKey || "").trim();
  return PHARMACY_FOLA_PROMPTS[key] || "";
}
